var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "el-form-title",
          attrs: { model: _vm.form, "label-width": "120px" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "故事名称" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入需要查询的故事名称" },
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
              _c("el-button", { on: { click: _vm.fetchData } }, [
                _vm._v("查询"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.showAddDialog },
                },
                [_vm._v("新增")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          attrs: {
            data: _vm.list,
            "element-loading-text": "Loading",
            height: "calc(100vh - 200px)",
            border: "",
            "header-cell-style": { background: "rgb(244 244 244)" },
            "empty-text": "暂无数据",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "故事名称",
              "min-width": "180",
              fixed: "left",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(" " + _vm._s(scope.row.name) + " ")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "描述", "min-width": "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(scope.row.description || "暂无")),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "创建时间", "min-width": "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.createTime))])]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "操作",
              "min-width": "500",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.editItem(scope.row)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.goToQA(scope.row.id)
                          },
                        },
                      },
                      [_vm._v("问题")]
                    ),
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.delItem(scope.row.id)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "新增故事",
            visible: _vm.addDialogVisible,
            width: "600px",
            top: "15%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.addDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "addForm",
              attrs: { model: _vm.addForm, "label-width": "120px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "故事名称", required: "" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入故事名称" },
                    model: {
                      value: _vm.addForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.addForm, "name", $$v)
                      },
                      expression: "addForm.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "故事描述" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      placeholder: "请输入故事描述",
                      rows: 3,
                    },
                    model: {
                      value: _vm.addForm.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.addForm, "description", $$v)
                      },
                      expression: "addForm.description",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "选择模板" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        placeholder: "请选择模板（可选）",
                        "value-key": "id",
                      },
                      model: {
                        value: _vm.addForm.templateId,
                        callback: function ($$v) {
                          _vm.$set(_vm.addForm, "templateId", $$v)
                        },
                        expression: "addForm.templateId",
                      },
                    },
                    _vm._l(_vm.templateList, function (template) {
                      return _c("el-option", {
                        key: template.id,
                        attrs: { label: template.name, value: template.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.addDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.confirmAdd } },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "编辑出题提示词",
            visible: _vm.questionPromptDialogVisible,
            width: "800px",
            height: "800px",
            top: "2%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.questionPromptDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "questionPromptForm",
              attrs: { model: _vm.questionPromptForm, "label-width": "120px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "出题提示词" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      placeholder: "请输入出题提示词",
                      rows: 20,
                    },
                    model: {
                      value: _vm.questionPromptForm.questionPrompt,
                      callback: function ($$v) {
                        _vm.$set(_vm.questionPromptForm, "questionPrompt", $$v)
                      },
                      expression: "questionPromptForm.questionPrompt",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.questionPromptDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmQuestionPrompt },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "编辑提示提示词",
            visible: _vm.tipPromptDialogVisible,
            width: "800px",
            height: "800px",
            top: "2%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.tipPromptDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "tipPromptForm",
              attrs: { model: _vm.tipPromptForm, "label-width": "120px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "提示提示词" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      placeholder: "请输入提示提示词",
                      rows: 20,
                    },
                    model: {
                      value: _vm.tipPromptForm.tipPrompt,
                      callback: function ($$v) {
                        _vm.$set(_vm.tipPromptForm, "tipPrompt", $$v)
                      },
                      expression: "tipPromptForm.tipPrompt",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.tipPromptDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmTipPrompt },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "编辑评分规则",
            visible: _vm.scoreRuleDialogVisible,
            width: "800px",
            height: "600px",
            top: "8%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.scoreRuleDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "scoreRuleForm",
              attrs: { model: _vm.scoreRuleForm, "label-width": "120px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "评分规则" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      placeholder: "请输入评分规则",
                      rows: 15,
                    },
                    model: {
                      value: _vm.scoreRuleForm.scoreRule,
                      callback: function ($$v) {
                        _vm.$set(_vm.scoreRuleForm, "scoreRule", $$v)
                      },
                      expression: "scoreRuleForm.scoreRule",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.scoreRuleDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmScoreRule },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }